import { Skeleton } from "@material-ui/lab";
import {
    Chip,
    FormControl,
    Grid,
    InputLabel,
    makeStyles,
} from "@material-ui/core";
import ShopifyAppInstallForm from "./ShopifyAppInstallForm";
import axios from "axios";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useState } from "react";
import { SwalWarn } from "../Popup";

const useStyles = makeStyles((theme) => ({
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
    copyInner: {
        display: "flex",
        [theme.breakpoints.down("xs")]: {
            flexGrow: 1,
        },
    },
    chipContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
    },
}));

const ShopifyAppSettingAuth = ({ userinfo, feedsetting, setFeedSettingReload, language }) => {
    const classes = useStyles();

    const [swalopen, setSwalOpen] = useState({
        open: false,
        message: "",
        okFunction: null,
    });

    const [feedsettingData, setFeedsettingData] = useState(feedsetting);
    const [loading, setLoading] = useState(false);

    function handleTestModeToggle(checked) {
        const api_test_mode = checked ? "ON" : "OFF";

        setLoading(true);
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/manage-test-token`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: {
                testMode: checked,
            },
        })
            .then((res) => {
                if (res.data.success) {
                    toast.dismiss();
                    toast.success(
                        `Test mode is now ${
                            checked ? "enabled" : "disabled"
                        }...`
                    );
                    setFeedsettingData((prev) => ({ ...prev, api_test_mode }));
                    setFeedSettingReload((prev) => prev + 1);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                } else if(error?.response?.data?.message){
                    toast.dismiss();
                    toast.warning(error?.response?.data?.message);
                }
            })
            .finally(() => {
                setLoading(false);
                setSwalOpen({
                    open: false,
                    message: "",
                    okFunction: null,
                });
            });
    }

    if (!feedsetting) {
        return (
            <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
            </>
        );
    }

    return (
        <div className="row">
            <div className="col-12 ccmode-setting-sticky-header">
                <div
                    className={`col-12 px-0 setting-title pb-5 border-bottom ${classes.cardHeader}`}
                >
                    <div className="d-flex flex-column">
                        <span>Shopify App AUTH SETTING</span>
                        <span className="small text-capitalize">
                            Shopify App auth setting
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-4">
                <Grid container spacing={3}>
                    <Grid item xs={12} className="my-6">
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-start"
                            justify="space-between"
                        >
                            <Grid item xs={12} md={6}>
                                <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                    Shopify Test Mode
                                    <span className="small d-block mt-2 line-height-lg">
                                        Enable test mode to show test data
                                    </span>
                                </InputLabel>
                            </Grid>
                            <Grid item>
                                {loading ? (
                                    <div
                                        class="spinner-border text-primary mr-4"
                                        role="status"
                                    >
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                ) : (
                                    ""
                                )}
                                {/* {feedsettingData?.api_test_mode !== "ON" && feedsettingData?.api_live_mode === 0 ? <span className="text-muted small mr-3 d-inline-block my-3">Action: Test Mode And Live Mode Both Are Off</span> : ""} */}
                                <FormControl required component="fieldset">
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            className="success"
                                            disabled={loading}
                                            checked={
                                                feedsettingData?.api_test_mode ===
                                                "ON"
                                            }
                                            onChange={(event) => {
                                                const checked =
                                                    event.target.checked;
                                                setSwalOpen({
                                                    open: true,
                                                    message: `Are You Sure You Want ${
                                                        checked
                                                            ? "Enable"
                                                            : "Disable"
                                                    } Test Mode?`,
                                                    okFunction: () =>
                                                        handleTestModeToggle(
                                                            checked
                                                        ),
                                                });
                                            }}
                                        />
                                        <span className="slider" />
                                    </label>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <hr className="w-100" />
                    <Grid item xs={12} className="my-6">
                        <ShopifyAppInstallForm
                            feedsetting={feedsetting}
                            language={language}
                        />
                    </Grid>
                    {/* {feedsetting?.shopify_scope ? (
                        <>
                            <hr className="w-100" />
                            <Grid item xs={12} className="my-6">
                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="flex-start"
                                >
                                    <Grid item xs={12} md={6}>
                                        <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                            Shopify Scopes
                                            <span className="small d-block mt-2 line-height-lg">
                                                Shopify Scopes
                                            </span>
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <div className={classes.chipContainer}>
                                            {feedsetting.shopify_scope
                                                .split(",")
                                                .map((el) => (
                                                    <Chip
                                                        key={el}
                                                        className="text-capitalize"
                                                        label={el
                                                            .split("_")
                                                            .join(" ")}
                                                        color="primary"
                                                        variant="outlined"
                                                    />
                                                ))}
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        ""
                    )} */}
                </Grid>
                <SwalWarn
                    show={swalopen.open}
                    message={swalopen.message}
                    onHide={() =>
                        setSwalOpen((prev) => ({ ...prev, open: false }))
                    }
                    onClose={() =>
                        setSwalOpen((prev) => ({ ...prev, open: false }))
                    }
                    responseOnOk={swalopen.okFunction}
                />
            </div>
        </div>
    );
};

export default ShopifyAppSettingAuth;
